import { useRouter } from '../../../RouterContext.js';
const useIsSubfolder = subfolder => {
  const _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  return pathname.includes(subfolder);
};
export { useIsSubfolder as default };
//# sourceMappingURL=useIsSubfolder.js.map
